import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import {
  getApiV1CourseregistrationEnrollmentGridChildrenQueryKey,
  getApiV1CourseregistrationEnrollmentGridQueryKey,
  usePostApiV1CourseregistrationEnrollmentCancel,
} from '@/shared/api/generated';

/**
 * Hook para cancelar uma matrícula (em inscrição ou ativa).
 * Chama POST /api/v1/courseregistration/enrollment/cancel e invalida o grid.
 *
 * @param onSuccess - Callback chamado após cancelamento bem-sucedido
 */
export function useCancelEnrollment(onSuccess: () => void) {
  const queryClient = useQueryClient();

  const { mutate, isPending: isCancelling } = usePostApiV1CourseregistrationEnrollmentCancel({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: getApiV1CourseregistrationEnrollmentGridQueryKey(),
        });
        void queryClient.invalidateQueries({
          queryKey: getApiV1CourseregistrationEnrollmentGridChildrenQueryKey(),
        });
        onSuccess();
      },
    },
  });

  const cancel = useCallback(
    (data: {
      enrollmentId: number;
      reasonId: string;
      subReasonId: string;
      observation: string;
    }) => {
      mutate({
        data: {
          courseRegistrationId: data.enrollmentId,
          statusReasonId: Number(data.reasonId),
          subStatusReasonId: data.subReasonId ? Number(data.subReasonId) : null,
          observation: data.observation,
        },
      });
    },
    [mutate],
  );

  return { cancel, isCancelling } as const;
}
